"use client";

import { Button, ButtonSize, ButtonVariant } from "@/components/ui/button";
import { createPath } from "@/service/routing/routing";
import { useRouter } from "@bprogress/next";
import { clientGet } from "@/service/client-api/client-api";
import { ReactNode, useContext } from "react";
import { UserContext } from "@/contexts/user-context";

export const DrawPatientButton = ({
  children,
  variant = "blue",
  size = "default",
  className,
  category,
}: {
  children: ReactNode;
  className?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  category?: number;
}) => {
  const router = useRouter();
  const { isLoggedIn } = useContext(UserContext);

  async function handleClick() {
    if (!isLoggedIn) {
      window.location.href = createPath("security.login");
      return;
    }

    const { categorySlug, slug } = await clientGet(
      "clinical_case.random_patient",
      {
        category: category ?? "",
      },
    );

    const path = createPath("clinical_case.show", {
      categorySlug,
      slug,
    });

    router.push(path);
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};
